import { AnyParsed } from "common/schemaParser"

export default abstract class BaseSse {
    public abstract sse(data: AnyParsed): void
}
